import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useTranslation } from "react-i18next";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const CommonPieChart = ({
  data = [],
  labels = [],
  colors = [],
  title = "",
  width = "300px",
  showLabels = true,
  onSegmentClick = () => {},
}) => {
  const { t } = useTranslation();
  const hasFullSegment = data.includes(100);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: title || t("base.chartData"),
        data: data,
        backgroundColor: colors,
        borderColor: "#fff",
        borderWidth: hasFullSegment ? 0 : 2,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          boxWidth: 12,
          padding: 10,
          color: "#333",
          font: {
            size: 14,
          },
          // Filter out legend items where data is 0
          filter: (legendItem, chartData) => {
            return chartData.datasets[0].data[legendItem.index] !== 0;
          },
          generateLabels: (chart) => {
            const dataset = chart.data.datasets[0];
            return chart.data.labels.map((label, index) => ({
              text: `${label}: ${dataset.data[index]}%`,
              fillStyle: dataset.backgroundColor[index],
              hidden: dataset.data[index] === 0,
              index,
            }));
          },
        },
        onClick: () => {},
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw || 0;
            return `${value}%`;
          },
        },
      },
      datalabels: {
        display: false,
        formatter: (value, context) => {
          const label = context.chart.data.labels[context.dataIndex];
          return `${value}% ${label}`;
        },
        color: "#000",
        backgroundColor: "#fff",
        borderColor: "#ddd",
        borderWidth: 1,
        borderRadius: 5,
        padding: 6,
        anchor: "end",
        align: "end",
        offset: 10,
        font: {
          size: 12,
        },
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const clickedElementIndex = elements[0].index;
        const label = labels[clickedElementIndex];
        const value = data[clickedElementIndex];
        onSegmentClick({ label, value, index: clickedElementIndex });
      }
    },
  };

  return (
    <div
      style={{
        width,
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
        maxWidth: "400px",
      }}
    >
      <Pie data={chartData} options={options} />
    </div>
  );
};

export default CommonPieChart;
